<template>
    <div>
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div v-if="loading" class="px-3 max-w-3xl m-auto my-5 leading-relaxed">
            <the-text-view :value="items[1].content"/>
        </div>
    </div>
</template>


<script>
    import TheSpinner from "../TheSpinner"
    import TheTextView from "../TheTextView";

    export default {
        name: 'homepage',
        components: {
            TheSpinner,
            TheTextView
        },
        data(){
            return{
                currentFilter: 'ALL',
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/static/'+this.$route.params.id+'.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        watch: {
            '$route.params.id': function (id) {
                this.loading = false;
                const baseURI = 'https://api.pgsi2020.de/api/file/static/'+this.$route.params.id+'.json'
                this.$http.get(baseURI)
                    .then((result) => {
                        this.items = result.data,
                            this.loading = true
                    })
            }
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }
    }
</script>
